import React, { useEffect, useState } from "react";
import { createMonsterStats, createNpcStats } from "lib/actions";
import { GameType, RequestType } from "types";
import * as Styled from "./CreateStatsForm.styled";
interface CreateStatsFormProps {
  imageId: string;
  requestType: RequestType; // Accepting RequestType as a prop
  onTaskCreated: (taskId: string) => void;
}
const CreateStatsForm: React.FC<CreateStatsFormProps> = ({
  imageId,
  requestType,
  onTaskCreated
}) => {
  const [name, setName] = useState("");
  const [level, setLevel] = useState<number | undefined>(0); // Used for both CR Level and NPC Level
  const [error, setError] = useState<string | null>(null);
  const [gameType, setGameType] = useState<GameType>(GameType.DND5e); // Default to D&D for now

  const getEntityType = (gameType: GameType, requestType: RequestType): string => {
    return `${gameType}${requestType}`;
  };
  useEffect(() => {
    setName(name || "");
    setLevel(level || 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (name && level !== undefined) {
      const entityType = getEntityType(gameType, requestType);
      try {
        let response;
        if (requestType === RequestType.MONSTER) {
          response = await createMonsterStats({
            imageId,
            name,
            crLevel: level,
            // For monsters, level is treated as CR Level
            entityType
          });
        } else if (requestType === RequestType.NPC) {
          response = await createNpcStats({
            imageId,
            name,
            level,
            // For NPCs, it's just Level
            entityType
          });
        }
        if (response && response.taskId) {
          onTaskCreated(response.taskId);
        } else {
          setError("Failed to create stats.");
        }
      } catch (error) {
        setError("Failed to create stats.");
      }
    }
  };
  return <Styled.FormContainer data-sentry-element="unknown" data-sentry-component="CreateStatsForm" data-sentry-source-file="index.tsx">
            <Styled.Form onSubmit={handleSubmit} data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                {error && <Styled.Error>{error}</Styled.Error>}
                <Styled.FormGroup data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                    <Styled.Label htmlFor="name" data-sentry-element="unknown" data-sentry-source-file="index.tsx">Name:</Styled.Label>
                    <Styled.Input type="text" id="name" value={name} onChange={e => setName(e.target.value)} required data-sentry-element="unknown" data-sentry-source-file="index.tsx" />
                </Styled.FormGroup>
                <Styled.FormGroup data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                    <Styled.Label htmlFor="level" data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                        {requestType === RequestType.MONSTER ? "CR Level" : "Level"}
                        :
                    </Styled.Label>
                    <Styled.Input type="number" id="level" value={level} onChange={e => setLevel(Number(e.target.value))} required data-sentry-element="unknown" data-sentry-source-file="index.tsx" />
                </Styled.FormGroup>
                <Styled.FormGroup data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                    <Styled.Label htmlFor="gameType" data-sentry-element="unknown" data-sentry-source-file="index.tsx">Game Type:</Styled.Label>
                    <Styled.Select id="gameType" value={gameType} onChange={e => setGameType(e.target.value as GameType)} required data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                        <option value={GameType.DND5e}>
                            Dungeons & Dragons 5th Edition
                        </option>
                    </Styled.Select>
                </Styled.FormGroup>
                <Styled.Button type="submit" data-sentry-element="unknown" data-sentry-source-file="index.tsx">Create Stats</Styled.Button>
            </Styled.Form>
        </Styled.FormContainer>;
};
export default CreateStatsForm;